import React from 'react'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo'
import { getPageMarginsZero } from '../../../../configurations/GlobalConfig'
import { BASE_URL, FOOTER_AVATAR, HEADER_AVATAR, MALE_DR_AVATAR } from '../../../../configurations/initUrls'
import moment from 'moment'

export const PrescriptionLetterPrint = React.forwardRef((props, ref) => {
    const data = props.printData
    const userData = getLoginInfo()
    return (
        <div ref={ref}>
            <style type="text/css">
                {getPageMarginsZero()}
            </style>
            {data &&
                <div className='h-full' style={{ fontSize: "10px" }}>
                    <div className='h-[1123px] flex flex-col justify-between'>
                        <div>
                            {userData &&
                                <img
                                    src={userData.isHeader == 1 ? BASE_URL + userData.headerUrl : HEADER_AVATAR}
                                    alt="Profile"
                                    className="w-full"
                                />
                            }
                        </div>
                        <div className='grow'>

                            <div className='mx-4'>
                                <hr class="w-full mt-3 h-px bg-gray-400 border-0" />
                                <div className='mx-1 flex justify-between text-[16px]'>
                                    <div>
                                        Ref No: {data.id}/{data.registeredIdForRef} |
                                        Opd Number: <span className='font-bold'>{data.confirmedAllotedNumber}</span>{data.confirmedAllotedNumber == data.opdNumberAlloted ? "" : "/" + data.opdNumberAlloted}
                                    </div>
                                    <div>
                                        Date: <span className='font-bold'>{moment(data.onDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                </div>
                                <hr class="w-full h-px bg-gray-400 border-0" />
                                <div className='mx-1 flex items-center justify-between gap-2 text-[16px]'>
                                    <span>Patient: <span className='font-bold'>{data.patientName.toUpperCase()} ({data.gender == 0 ? "M" : "F"})</span></span>
                                    <span>BP: {data.bloodPressure} </span>
                                    <span>W: {data.weight}Kg </span>
                                    <span>Age: {data.age}Y</span>
                                    <span>BG: {data.bloodGroup} </span>
                                </div>
                                <hr class="w-full h-px bg-gray-400 border-0" />
                            </div>
                        </div>
                        <div className='flex flex-col items-end justify-end'>
                            {userData &&
                                <img
                                    src={userData.isFooter == 1 ? BASE_URL + userData.footerUrl : FOOTER_AVATAR}
                                    alt="Profile"
                                    className="w-full"
                                />
                            }
                        </div>
                    </div>
                </div>
            }
        </div >
    )
})
